import React, { Component, useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import SettingsSidebar from "../Sidebar/settingsidebar";
import swal from 'sweetalert';
import Header from "../Sidebar/header";
import Approval from "../../assets/img/profiles/approval.svg";
import Edit from "../../assets/img/profiles/edit.svg";
import Select from "react-select";
import { FaMinus, FaPlus } from "react-icons/fa";
import axios from "axios";

export const ApprovalLevel = () => {
  const [menu, setMenu] = useState(false);
  const [displayPage, setDisplayPage] = useState("leave"); // 'leave', 'attendance', 'reimbursement'
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    department: null,
    moduleType: 'leave', // default to leave
    approvalHierarchy: null, // who gets approved
    approverHierarchy: [], // who approves
    approvalType: 'any' // 'any' or 'all'
  });
  
  // Sample data - these would come from your backend
  const [departments, setDepartments] = useState([
    { value: 'hr', label: 'Human Resources' },
    { value: 'it', label: 'Information Technology' },
    { value: 'finance', label: 'Finance' }
  ]);
  
  const [approvalHierarchyOptions, setApprovalHierarchyOptions] = useState([
    { value: 'manager', label: 'Manager' },
    { value: 'team_lead', label: 'Team Lead' },
    { value: 'director', label: 'Director' },
    { value: 'vp', label: 'Vice President' },
    { value: 'executive', label: 'Executive' }
  ]);
  
  const [approverLevels, setApproverLevels] = useState([
    { value: 'level1', label: 'Level 1' },
    { value: 'level2', label: 'Level 2' },
    { value: 'level3', label: 'Level 3' },
    { value: 'level4', label: 'Level 4' },
    { value: 'level5', label: 'Level 5' },
    { value: 'level6', label: 'Level 6' }
  ]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleInputChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value
    });
    
    // If module type changes, you might want to fetch different options from backend
    if (field === 'moduleType') {
      // Here you would typically make an API call to get options for this module type
      // For now we'll just use the same options
    }
  };

  const handleSubmit = () => {
    // Prepare data for API call
    const payload = {
      department: formData.department?.value,
      module_type: formData.moduleType,
      approval_hierarchy: formData.approvalHierarchy?.value,
      approver_hierarchy: formData.approverHierarchy.map(level => level.value),
      approval_type: formData.approvalType
    };
    
    console.log('Submitting:', payload);
    // Here you would make your API call
    // axios.post('/api/approval-levels', payload).then(...)
    
    // Close modal after submission
    setShowModal(false);
  };

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />
      <SettingsSidebar />
      <div className="page-wrapper">
        <div className="row">
          <div className="col-md-12">
            <div className="row align-items-center">
              <div className="col">
                <h4>
                  <img src={Approval} alt="Approval" /> <span>Approval Level Hierarchy</span>
                </h4>
              </div>
              <div className="col-auto float-end">
                <button
                  className="btn btn-primary"
                  style={{
                    padding: "5px 20px",
                    fontSize: "15px",
                    background: "#477BFF",
                    border: "none",
                    color: "white",
                  }}
                  onClick={() => setShowModal(true)}
                >
                  + Add Approval Level
                </button>
              </div>
            </div>
            
            {/* Toggle buttons for leave/attendance/reimbursement */}
            <div className="row mt-3">
              <div className="col-md-12">
                <div className="btn-group" role="group">
                  <button
                    type="button"
                    className={`btn ${displayPage === "leave" ? "btn-primary" : "btn-light"}`}
                    style={{
                      borderRadius: "8px 0px 0px 8px",
                      border: "1px solid #dee2e6"
                    }}
                    onClick={() => setDisplayPage("leave")}
                  >
                    Leave
                  </button>
                  <button
                    type="button"
                    className={`btn ${displayPage === "attendance" ? "btn-primary" : "btn-light"}`}
                    style={{
                      borderRadius: "0px",
                      border: "1px solid #dee2e6"
                    }}
                    onClick={() => setDisplayPage("attendance")}
                  >
                    Attendance
                  </button>
                  <button
                    type="button"
                    className={`btn ${displayPage === "reimbursement" ? "btn-primary" : "btn-light"}`}
                    style={{
                      borderRadius: "0px 8px 8px 0px",
                      border: "1px solid #dee2e6"
                    }}
                    onClick={() => setDisplayPage("reimbursement")}
                  >
                    Reimbursement
                  </button>
                </div>
              </div>
            </div>
            
            {/* Main content area where you'd display the approval levels */}
            <div className="row mt-4">
              <div className="col-md-12">
                {/* Here you would map through your approval levels data */}
                <div className="card">
                  <div className="card-body">
                    <p>Approval levels will be displayed here</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Modal for adding new approval level */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Approval Hierarchy</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Department</label>
                  <Select
                    options={departments}
                    value={formData.department}
                    onChange={(selected) => handleInputChange('department', selected)}
                    placeholder="Select Department"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Module Type</label>
                  <select
                    className="form-select"
                    value={formData.moduleType}
                    onChange={(e) => handleInputChange('moduleType', e.target.value)}
                  >
                    <option value="leave">Leave</option>
                    <option value="attendance">Attendance</option>
                    <option value="reimbursement">Reimbursement</option>
                  </select>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Approval Hierarchy</label>
                  <Select
                    options={approvalHierarchyOptions}
                    value={formData.approvalHierarchy}
                    onChange={(selected) => handleInputChange('approvalHierarchy', selected)}
                    placeholder="Select who needs approval"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Approver Hierarchy</label>
                  <Select
                    isMulti
                    options={approverLevels}
                    value={formData.approverHierarchy}
                    onChange={(selected) => handleInputChange('approverHierarchy', selected)}
                    placeholder="Select approver levels"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Approval Type</label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="approvalType"
                      id="approvalTypeAny"
                      value="any"
                      checked={formData.approvalType === 'any'}
                      onChange={() => handleInputChange('approvalType', 'any')}
                    />
                    <label className="form-check-label" htmlFor="approvalTypeAny">
                      Any approver can approve (single level approval)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="approvalType"
                      id="approvalTypeAll"
                      value="all"
                      checked={formData.approvalType === 'all'}
                      onChange={() => handleInputChange('approvalType', 'all')}
                    />
                    <label className="form-check-label" htmlFor="approvalTypeAll">
                      All selected approvers must approve (multi-level approval)
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};